import React from 'react';
import { Link } from 'react-router-dom';
import { useCatalog } from '../../context/CatalogContext';
import './CategoryGrid.css';

const CategoryGrid = () => {
  const { categories } = useCatalog();
  return (
    <section className="category-grid-section">
      <div className="container">
        <h2 className="section-title">Popular Categories this Week</h2>
        
        <div className="category-grid">
          {categories.map(category => (
            <Link 
              to={`/category/${category.slug}`} 
              key={category.id}
              className="category-card"
            >
              <div className="category-image-wrapper">
                {category.image ? (
                  <>
                    <img src={category.image} alt={category.name} className="category-image" />
                    <div className="category-icon">{category.icon}</div>
                  </>
                ) : (
                  <div className="category-placeholder">
                    <span className="category-icon-large">{category.icon}</span>
                  </div>
                )}
              </div>
              <div className="category-info">
                <h3>{category.name}</h3>
                <p>{category.description}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CategoryGrid;
